import React from 'react';
import { Modal, Image, Spin } from 'antd';
import './selectMediaModal.less';

interface MediaItem {
  id: string;
  src: string;
  type: string;
}

interface SelectMediaModalProps {
  isOpen: boolean;
  onClose: () => void;
  mediaList: MediaItem[];
  onSelectMedia: (mediaId: string) => void;
  modalFor: string;
}

const SelectMediaModal: React.FC<SelectMediaModalProps> = ({
  isOpen,
  onClose,
  mediaList,
  onSelectMedia,
  modalFor
}) => {
  return (
    <Modal
      title={modalFor === 'crop' ? "Select Media to Crop" : "Select Video to Trim"}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={800}
      centered
    >
      <div className="media-grid">
        {mediaList.map((media) => (
          <div
            key={media.id}
            className="media-item"
            onClick={() => onSelectMedia(media.id)}
          >
            {media.type === 'video' ? (
              <video
                src={media.src}
                className="media-preview"
                muted
                loop
                playsInline
              />
            ) : (
              <Image
                src={media.src}
                className="media-preview"
                preview={false}
                alt="Media preview"
              />
            )}
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default SelectMediaModal; 